import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import MessageIcon from '@material-ui/icons/Message';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';

const useStyles = makeStyles((theme) => ({
  notify: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  text: {
    padding: '8px 0',
    whiteSpace: 'pre-wrap',
  },
  questions: {
    width: '100%',
  },
  checkbox: {
    '& label': {
      cursor: 'pointer',
    },
    '& > td': {
      '& > span': {
        marginLeft: -theme.spacing(1.5),
      },
    },
  },
  title: {
    '& span': {
      fontWeight: 400,
    },
  },
}));

function Sops(props) {
  const classes = useStyles();
  const { no, update, sop } = props;
  const { DispatcherQuestions, DispatcherMessage, SOPID, ParentType, ParentName, ptsSOPID } = sop;

  const updateQuestion = (idx) => (ev) => {
    const value = ev.target.value;
    const newSop = { ...sop };
    newSop.DispatcherQuestions[idx] = {
      ...newSop.DispatcherQuestions[idx],
      value,
    };
    update(newSop);
  };

  const updateCheckbox = (idx) => (ev) => {
    const value = ev.target.checked;
    const newSop = { ...sop };
    newSop.DispatcherQuestions[idx] = {
      ...newSop.DispatcherQuestions[idx],
      value,
    };
    update(newSop);
  };

  const renderText = (text) => {
    return (
      <tr key={text.name}>
        <td colSpan={2} className={classes.text}>
          <MessageIcon /> &nbsp;{text.text}
        </td>
      </tr>
    );
  };

  const renderQuestion = (question, idx) => {
    return (
      <tr key={question.name}>
        <td>
          <QuestionAnswerIcon /> &nbsp;{question.text}
        </td>
        <td>
          {
            <TextField
              variant="outlined"
              size="small"
              style={{ width: '100%' }}
              value={question.value}
              onChange={updateQuestion(idx)}
            />
          }
        </td>
      </tr>
    );
  };

  const renderCheckbox = (checkbox, idx) => {
    const value = checkbox.value === true || checkbox.value === 'True';
    const id = `sop-checkbox-${ptsSOPID}-${idx}`;
    return (
      <tr key={checkbox.name} className={classes.checkbox}>
        <td>
          <label htmlFor={id}>{checkbox.text}</label>
        </td>
        <td>
          <Checkbox checked={value} onChange={updateCheckbox(idx)} id={id} />
        </td>
      </tr>
    );
  };

  if (!sop) return '';

  return (
    <div>
      {no > 0 && <hr />}
      <h5 className={classes.title}>
        {SOPID}{' '}
        <span>
          ({ParentType} - {ParentName})
        </span>
      </h5>
      <p>
        <strong>Notification text:</strong> {DispatcherMessage}
      </p>
      <h5>Actions</h5>
      <table className={classes.questions}>
        <tbody>
          {DispatcherQuestions.map((q, idx) => {
            switch (q.type) {
              case 'Text':
                return renderText(q);
              case 'Question':
                return renderQuestion(q, idx);
              case 'CheckBox':
                return renderCheckbox(q, idx);
              default:
                return '';
            }
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Sops;
